import axios from '@/api/axios';
import lang from '@/lang';
import Vapi from 'vuex-rest-api';

const store = new Vapi({
  axios,
  state: {
    permissions: [],
  },
})
  .get({
    action: 'getPayeeAccess',
    path: 'payee/access',
    headers: ({ tenantId }) => ({
      tenantId,
    }),
  })
  .get({
    action: 'getPayeeAdmins',
    path: 'payee/access/admins',
  })
  .post({
    action: 'addPayeeRole',
    path: 'tenants/roles',
    headers: ({ tenantId }) => ({
      tenantId,
    }),
  })
  .put({
    action: 'setPayeeRoles',
    path: 'tenants/roles/set',
    headers: ({ tenantId }) => ({
      tenantId,
    }),
  })
  .put({
    action: 'removePayeeRole',
    path: 'tenants/roles/remove',
    headers: ({ tenantId }) => ({
      tenantId,
    }),
  })
  .get({
    action: 'getUserPermissions',
    path: 'user/access',
    property: 'permissions',
  })
  .getStore();

store.getters = {
  permissions: (s) => s.permissions,
  systemAdmin: (s) => s.permissions.some((x) => x.type === 'SystemAdmin'),
  tenantAdmin: (s, g, rs, rg) => g.systemAdmin
  || s.permissions.some((x) => x.type === 'TenantAdmin'
  && x.tenantId === rg.payee?.ownerId),
  payeeAdmin: (s, g, rs, rg) => g.tenantAdmin
    || s.permissions.some((x) => x.type === 'PayeeAdmin' && x.scope?.payeeId === rg.payeeId),
  anyCategoryAccess: (s, g, rs, rg) => g.tenantAdmin || g.payeeAdmin
    || s.permissions.some((x) => x.type === 'BillingCategoryView' && x.scope?.payeeId === rg.payeeId),
  canSharePaymentLink: (s, g, rs, rg) => (payerGroups, billCategoryIds) => g.payeeAdmin
    || (s.permissions.some((x) => x.type === 'PayersView' && x.scope?.payeeId === rg.payeeId
      && (x.scope.groupCode === '#all' || (payerGroups || []).includes(x.scope.groupCode)))
    && s.permissions.some((x) => x.type === 'BillingCategoryView' && x.scope?.payeeId === rg.payeeId
      && (billCategoryIds || []).includes(x.scope.categoryId))),
  anyCatalogAdmin: (s, g, rs, rg) => g.payeeAdmin
    || s.permissions.some((x) => x.type === 'ShopCatalogAdmin' && x.scope?.payeeId === rg.payeeId),
  roleTypes() {
    return [
      {
        key: 'PayeeAdmin',
        icon: 'fas fa-user-tie',
        text: lang.t('settings.roles.types.payeeAdmin'),
      },
      {
        key: 'MessageAdmin',
        icon: 'fas fa-comments',
        text: lang.t('settings.roles.types.payersMessageView'),
      },
      {
        key: 'PayersView',
        icon: 'fas fa-users',
        text: lang.t('settings.roles.types.payersView'),
      },
      {
        key: 'BillingCategoryView',
        icon: 'fas fa-box-dollar',
        text: lang.t('settings.roles.types.billingCategoryView'),
      },
      {
        key: 'ShopCatalogAdmin',
        icon: 'fas fa-store',
        text: lang.t('settings.roles.types.shopCatalogAdmin'),
      },
      {
        key: 'ShopOrdersView',
        icon: 'fas fa-store',
        text: lang.t('settings.roles.types.shopOrdersView'),
      },
    ];
  },
};

export default store;
